import { c as _c } from "react/compiler-runtime";
import type { SkillFileNode } from '@onefootprint/request-types/dashboard';
import { createContext, type ReactNode, useContext, useState } from 'react';
import type { DropPosition } from '../utils/skills-path';
export type DropTarget = {
  position: DropPosition;
  path: string;
  onDrop: (nodes: SkillFileNode[], position: DropPosition) => void;
};
type DropTargetContextValue = {
  dropTarget: DropTarget | null;
  setDropTarget: (target: DropTarget | null) => void;
};
const DropTargetContext = createContext<DropTargetContextValue>({
  dropTarget: null,
  setDropTarget: () => {}
});
type DropTargetProviderProps = {
  children: ReactNode;
};
export const DropTargetProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [dropTarget, setDropTarget] = useState(null);
  let t1;
  if ($[0] !== dropTarget) {
    t1 = {
      dropTarget,
      setDropTarget
    };
    $[0] = dropTarget;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <DropTargetContext.Provider value={t1}>{children}</DropTargetContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useDropTarget = () => {
  return useContext(DropTargetContext);
};